import { styled } from '@mui/material';
import { ChipField as AdminChipField, ChipFieldProps as AdminChipFieldProps } from 'react-admin';

export type ChipFieldProps = AdminChipFieldProps;

export const ChipField = styled(AdminChipField)({
  height: '24px',
});
